import Heroku from './assets/heroku.png';
import HtmlCss from './assets/htmlcss.png';
import Javascript from './assets/javascript.png';
import Netlify from './assets/netlify.png';
import Nodejs from './assets/nodejs.png';
import React from './assets/react.png';

const cards = [
  {
    id: 1,
    slug: 'heroku',
    image: Heroku,
    turned: false
  },
  {
    id: 2,
    slug: 'htmlcss',
    image: HtmlCss,
    turned: false
  },
  {
    id: 3,
    slug: 'htmlcss',
    image: HtmlCss,
    turned: false
  },
  {
    id: 4,
    slug: 'javascript',
    image: Javascript,
    turned: false
  },
  {
    id: 6,
    slug: 'netlify',
    image: Netlify,
    turned: false
  },
  {
    id: 7,
    slug: 'nodejs',
    image: Nodejs,
    turned: false
  },
  {
    id: 8,
    slug: 'javascript',
    image: Javascript,
    turned: false
  },
  {
    id: 9,
    slug: 'netlify',
    image: Netlify,
    turned: false
  },
  {
    id: 10,
    slug: 'react',
    image: React,
    turned: false
  },
  {
    id: 11,
    slug: 'nodejs',
    image: Nodejs,
    turned: false
  },
  {
    id: 12,
    slug: 'react',
    image: React,
    turned: false
  },
  {
    id: 5,
    slug: 'heroku',
    image: Heroku,
    turned: false
  },
]

export default cards;